for (const form of document.querySelectorAll('[data-address-api-url]')) {
    const apiUrl = form.dataset.addressApiUrl;
    const postalCodeInput = form.querySelector('[name="address[postalCode]"]');
    const postalCodeErrorMessage = postalCodeInput.parentElement.querySelector('div[id$=_help]');
    const houseNumberInput = form.querySelector('[name="address[houseNumber]"]');
    const houseNumberAdditionInput = form.querySelector('[name="address[houseNumberAddition]"]');
    const streetInput = form.querySelector('[name="address[street]"]');
    const cityInput = form.querySelector('[name="address[city]"]');
    const submitButton = form.querySelector('[type="submit"]');
    const checkAddressButton = form.querySelector('[data-address-api-check]');
    const hiddenInputs = form.querySelector('[data-address-api-hidden]');

    hiddenInputs.classList.add('hidden');
    submitButton.classList.add('hidden');
    checkAddressButton.classList.remove('hidden');

    checkAddressButton.addEventListener('click', () => {
        const strip = (input) => input.replace(/\s/g, '');

        let requestUrl = `${apiUrl}/${strip(postalCodeInput.value)}/${strip(houseNumberInput.value)}`;
        if (!houseNumberAdditionInput.value.trim().length && houseNumberAdditionInput.value !== '') {
            requestUrl += `/${strip(houseNumberAdditionInput.value)}`;
        }

        fetch(requestUrl, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => response.json())
            .then((data) => {
                if (Object.prototype.hasOwnProperty.call(data, 'error')) {
                    if (data['error'] === 'INVALID_POSTAL_CODE' || data['error'] === 'NO_ADDRESS_FOUND') {
                        postalCodeInput.classList.add('error');
                        postalCodeErrorMessage.classList.remove('hidden', 'text-gray-500', 'dark:text-gray-300');
                        postalCodeErrorMessage.classList.add('text-red-600', 'dark:text-red-400');
                        postalCodeErrorMessage.innerText = 'Geen adres gevonden. Controleer je postcode en huisnummer.';
                    } else {
                        postalCodeInput.classList.remove('error');
                        postalCodeErrorMessage.classList.add('hidden');
                        hiddenInputs.classList.remove('hidden');
                        submitButton.classList.remove('hidden');
                        checkAddressButton.classList.add('hidden');
                    }

                    return;
                }

                streetInput.value = data['street'];
                cityInput.value = data['city'];
                form.submit();
            })
            .catch((error) => {
                console.log(error);
                alert('Er heeft zich in fout voorgedaan. Probeer het later opnieuw.');
            });
    });
}
